export const BUSINESS = {
  name: "Teign Gas",
  phone: "07737 016265",
  phoneHref: "tel:+447737016265",
  email: "teigngas@outlook.com",
  facebook: "https://www.facebook.com/p/Teign-Gas-61554672873156/",
  google: "https://www.google.com/search?kgmid=/g/11yrchntmc&q=Teign+Gas",
  gasSafe: "951592",
  whatsapp: "https://wa.me/447737016265?text=Hi%20Teign%20Gas%2C%20I%27d%20like%20some%20help%20with%20my%20boiler",
  areas: ["Exeter", "Newton Abbot", "Teignmouth", "Bovey Tracey", "Chudleigh", "Torquay", "Paignton", "Brixham", "Ashburton", "Liverton", "Dawlish", "+ all surrounding South Devon areas"],
};

export const SERVICES = [
  {
    id: "boiler_service",
    name: "Annual Boiler Service",
    price: 85.99,
    priceLabel: "£85.99",
    tag: "MOST POPULAR",
    desc: "Full 18-point safety check, flue gas analysis, filter clean and Gas Safe validation certificate.",
    badge: "FIXED PRICE",
    duration: "60–90 MINS",
  },
  {
    id: "boiler_cooker_bundle",
    name: "Boiler + Cooker Bundle",
    price: 105,
    priceLabel: "£105",
    tag: "BEST VALUE",
    desc: "Annual boiler service and cooker & hob service together — one visit, one payment, both appliances certified safe.",
    badge: "SAVE £77",
    duration: "ONE VISIT",
  },
  {
    id: "emergency_callout",
    name: "Emergency Breakdown Callout",
    price: 95.99,
    priceLabel: "£95.99",
    tag: "24/7 RAPID",
    desc: "Boilers, radiators, fires, cookers and hobs — immediate dispatch across South Devon. First hour of diagnostics and fix attempt included.",
    badge: "SAME DAY",
    duration: "FIRST HOUR INCL.",
  },
  {
    id: "cooker_service",
    name: "Cooker & Hob Service",
    price: 95.99,
    priceLabel: "£95.99",
    tag: "£105 BUNDLE WITH BOILER",
    desc: "Full safety check and service of gas cookers and hobs — burners, ignition, flame picture and gas tightness test.",
    badge: "FIXED PRICE",
    duration: "45–60 MINS",
  },
  {
    id: "fire_service",
    name: "Gas Fire Service",
    price: 95.99,
    priceLabel: "£95.99",
    tag: "INCL. SMOKE TEST",
    desc: "Complete gas fire service including chimney smoke test, burner clean, and ventilation & flue safety checks.",
    badge: "FIXED PRICE",
    duration: "45–60 MINS",
  },
  {
    id: "plumbing_breakdown",
    name: "Plumbing Breakdown",
    price: 95.99,
    priceLabel: "£95.99",
    tag: "SAME DAY",
    desc: "Leaks, bursts, taps, toilets and radiator faults — diagnosed and fixed fast. First hour included.",
    badge: "FIRST HOUR INCL.",
    duration: "RAPID RESPONSE",
  },
  {
    id: "smart_controls",
    name: "Smart Heating Controls",
    price: 150,
    priceLabel: "FROM £150",
    tag: "FROM £150 FITTED",
    desc: "Hive, Nest and smart thermostats supplied & fitted — control your heating from anywhere, straight from your phone.",
    badge: "SMART HOME",
    duration: "SETUP INCL.",
  },
  {
    id: "power_flush",
    name: "System Power Flush",
    price: 350,
    priceLabel: "£350",
    tag: "FROM £350",
    desc: "High-velocity chemical flush of your radiators and pipework — kills cold spots, silences a noisy boiler and cuts heating bills.",
    badge: "DEEP CLEAN",
    duration: "HALF DAY",
  },
  {
    id: "unvented_service",
    name: "Unvented Hot Water Tank Service",
    price: 25,
    priceLabel: "FROM £25",
    tag: "HOT WATER",
    desc: "Safety valve, expansion vessel and pressure checks on your unvented cylinder — keeps hot water safe and reliable.",
    badge: "SAFETY CHECK",
    duration: "30–45 MINS",
  },
  {
    id: "gas_safety",
    name: "Gas Safety Certificate (CP12)",
    price: 75,
    priceLabel: "£75",
    tag: "LANDLORDS",
    desc: "Official CP12 compliance audit for landlords and home buyers, with instant digital certificate.",
    badge: "LEGAL STANDARD",
    duration: "45–60 MINS",
  },
];

export const GALLERY = [
  {
    url: "/images/work-boiler.webp",
    category: "Boiler Installs",
    caption: "New combi boiler install — fresh copper pipework",
  },
  {
    url: "/images/work-service.webp",
    category: "Servicing",
    caption: "Annual boiler service — strip-down and clean",
  },
  {
    url: "/images/work-fire.webp",
    category: "Gas Fires",
    caption: "Gas fire serviced — burning clean and true",
  },
  {
    url: "/images/work-hob.jpg",
    category: "Cookers & Hobs",
    caption: "Gas hob serviced — flame picture and tightness checked",
  },
  {
    url: "/images/work-cylinder.jpg",
    category: "Hot Water",
    caption: "Unvented hot water cylinder — safety valve & pressure check",
  },
  {
    url: "/images/heatpump-house.jpg",
    category: "Heat Pumps",
    caption: "Air source heat pump installation",
  },
  {
    url: "/images/heatpump-unit.jpg",
    category: "Heat Pumps",
    caption: "Heat pump outdoor unit — annual service",
  },
  {
    url: "/images/work-tap.webp",
    category: "Plumbing",
    caption: "New kitchen tap supplied & fitted",
  },
  {
    url: "/images/work-radiator.webp",
    category: "Plumbing",
    caption: "Designer vertical radiator installed",
  },
];

export const REVIEWS = [
  {
    name: "Michael Burnett Hall",
    time: "3 days ago",
    text: "We returned from holiday to find our gas hobs faulty. Teign Gas offered to visit that same evening — the issue was fixed quickly, with helpful advice on maintenance and future servicing. Genuinely impressed; highly recommended.",
  },
  {
    name: "Rachael Walton",
    time: "2 weeks ago",
    text: "Excellent service — Brad came out to replace my boiler, a big job, arrived promptly and worked the entire day to get it done. He services our boiler every year and is always polite and happy to help. The highest possible standard.",
  },
  {
    name: "John Seymour",
    time: "A month ago",
    text: "Brad serviced our boiler and fixed two separate leaks efficiently and to a high standard. Arrived exactly on time and the certificate came through promptly afterwards. Second time using Teign Gas — great service both times.",
  },
];

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const COVERAGE = [
  { name: "Exeter", slug: "exeter", coords: [50.7236, -3.5275] },
  { name: "Newton Abbot", slug: "newton-abbot", coords: [50.5303, -3.6085] },
  { name: "Teignmouth", slug: "teignmouth", coords: [50.547, -3.4964] },
  { name: "Bovey Tracey", slug: "bovey-tracey", coords: [50.5928, -3.6727] },
  { name: "Chudleigh", slug: "chudleigh", coords: [50.606, -3.6003] },
  { name: "Torquay", slug: "torquay", coords: [50.4619, -3.5253] },
  { name: "Paignton", slug: "paignton", coords: [50.4351, -3.5643] },
  { name: "Brixham", slug: "brixham", coords: [50.3927, -3.5158] },
  { name: "Ashburton", slug: "ashburton", coords: [50.5158, -3.7511] },
  { name: "Liverton", slug: "liverton", coords: [50.5478, -3.683] },
  { name: "Dawlish", slug: "dawlish", coords: [50.5811, -3.4664] },
];
